import axios from 'axios';

const tempApi = axios.create({
	baseURL: process.env.VUE_APP_BASE_URL_API2,
	headers: {
		'Content-Type': 'application/json'
	},
	timeout: 60000
});

export default tempApi;